import {
  BackUrl,
  requestTypeMapping
} from '@/modules/utilities/notification/utils/notificationMapping.ts'

/**
 * Convierte una URL del backend a su correspondiente URL del frontend.
 * @param {string} backendUrl - La URL proveniente del backend (ej: "/credit-change-requests/27").
 * @returns {string|null} La URL formateada para el frontend o null si el formato es inválido o no se encuentra el mapeo.
 */
export function mapBackToFrontNotifications(backendUrl: string): string | null {
  const parts = backendUrl.split('/').filter(Boolean)

  const backendPathKey = parts[0] as BackUrl
  const id = parts[1]

  const mapping = requestTypeMapping[backendPathKey]

  if (!mapping) {
    console.warn(
      `No se encontró un mapeo para el tipo de solicitud: ${backendPathKey}`
    )
    return null
  }

  const { frontPath, requestType } = mapping

  switch (backendPathKey) {
    case 'video':
      return `/teaching/videoList`
    default: {
      if (!id) {
        console.warn(
          `URL del backend no tiene el formato esperado: ${backendUrl}`
        )
        return null
      }
      return `${frontPath}/${id}/details?requestType=${requestType}`
    }
  }
}
